import { useEffect, useState } from "react";
import { getPendingEmails } from "../api";
import "./Inbox.css";

export default function ApprovalInbox({ onSelectEmail, selectedEmailId }) {
  const [pendingEmails, setPendingEmails] = useState([]);
  const [loading, setLoading] = useState(true);

  async function loadPending() {
    setLoading(true);
    try {
      const data = await getPendingEmails();
      const emailList = Array.isArray(data) ? data : data.results || [];
      setPendingEmails(emailList);
    } catch (err) {
      console.error("Pending load error", err);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadPending();
  }, []);

  if (loading) return <div className="inbox-empty">იტვირთება...</div>;

  if (pendingEmails.length === 0)
    return <div className="inbox-empty">მოლოდინში მყოფი წერილები არ არის</div>;

  return (
    <div className="inbox-container">
      <div className="inbox-list">
        {pendingEmails.map((email) => (
          <div
            key={email.id}
            className={`inbox-item ${selectedEmailId === email.id ? "active" : ""}`}
            onClick={() => onSelectEmail(email)}
          >
            <div className="inbox-item-header">
              <span className="inbox-from">{email.from_email}</span>
              <span className="inbox-date">
                {new Date(email.processed_at).toLocaleDateString("ka-GE")}
              </span>
            </div>
            <div className="inbox-subject">
              {email.subject}
              <span className="urgency-tag საშუალო" style={{ marginLeft: 8 }}>
                მოლოდინში
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
